@if (isExtraSmall$ | async) {
  <div class="w-100 d-flex flex-row align-items-center justify-content-end">
    <button mat-icon-button (click)="openRecorder()"><mat-icon>mic</mat-icon></button>
  </div>
}
